// extracted by mini-css-extract-plugin
export default {"ItemTitle":"HistoricalCampaignCard_ItemTitle__vtFLh","ItemTime":"HistoricalCampaignCard_ItemTime__3kJnK","ItemContent":"HistoricalCampaignCard_ItemContent__6TAaF"};